var Partial = require('./partial');

module.exports = Partial();



//////////////////
// WEBPACK FOOTER
// ./~/vdom-thunk/index.js
// module id = 176
// module chunks = 0